import React from 'react';

import { useQuery } from '@apollo/client';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import YouTubeIcon from '@material-ui/icons/YouTube';
import PropTypes from 'prop-types';

import auth from '../../services/Auth';
import cmsRequest from '../../services/cms/gqlSchema';
import footerLinks from './FooterLinks';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

const DefaultFooter = props => {
  const currentContactCompany = auth.findUserCompany();
  // Find footer links
  let footerLinkIds = [];
  if (currentContactCompany?.code === 'CAPIFRANCE') {
    footerLinkIds = footerLinks.CAPIFRANCE.map(link => link.id);
  }

  const { loading, data } = useQuery(cmsRequest.Query.findPages, {
    variables: {
      filters: {
        id: {
          in: footerLinkIds,
        },
      },
    },
  });
  let footerLinksItems;
  if (!loading) {
    footerLinksItems = footerLinkIds.map(id => {
      return data?.cmsPages?.hits.find(
        page =>
          id === page.id && {
            name: page.name,
            id: page.id,
            type: page.type,
          },
      );
    });
  }

  // eslint-disable-next-line
  const { children, ...attributes } = props;

  const currentYear = new Date().getFullYear();

  return (
    <React.Fragment>
      <span>
        <a style={{ marginRight: '0.5em' }} href='https://www.digitregroup.com/'>
          DigitRE Group
        </a>
        &copy; {currentYear}.
      </span>
      <div className={'flex-fill'}>
        <div className={'text-center'}>
          {!loading &&
            data &&
            footerLinksItems.length > 0 &&
            footerLinksItems.map((page, i) => {
              const type = page?.type === 'HUB' ? 'hub' : 'page';

              return (
                <span key={i}>
                  <a href={'/#/cms/' + type + '/' + page?.id} className={'mx-2 text-capitalize'}>
                    {page?.name.toLowerCase()}
                  </a>
                  {i < footerLinksItems.length - 1 && `|`}
                </span>
              );
            })}
          {!loading && data && footerLinksItems.length > 0 && (
            <>
              <span> | </span>
              <a className={'mx-2'} href={'https://www.facebook.com/capifrance/?ref=br_rs'} target={'blank'}>
                <FacebookIcon />
              </a>
              <a
                className={'mr-2'}
                href={'https://www.linkedin.com/company/capifrance/?originalSubdomain=fr'}
                target={'blank'}
              >
                <LinkedInIcon />
              </a>
              <a href={'https://www.youtube.com/user/capifrance'} target={'blank'}>
                <YouTubeIcon />
              </a>
            </>
          )}
        </div>
      </div>
      <span className='ml-auto'>Powered by Digital Factory</span>
    </React.Fragment>
  );
};

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default DefaultFooter;
